import { SwitchProductModule } from '../switch-product.module';
export const useSwitchFlows = () => {
  var _isSwitchFlowQuery$da;
  const {
    isDowngradeEnabled
  } = SwitchProductModule.internals.useContext();
  const isSwitchFlowQuery = SwitchProductModule.SDK.switchApiClient.hooks.useIsSwitchFlow({});
  const currentProductQuery = SwitchProductModule.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const isSwitchFlow = (_isSwitchFlowQuery$da = isSwitchFlowQuery.data) == null ? void 0 : _isSwitchFlowQuery$da.isSwitchFlow;
  const allQueries = [isSwitchFlowQuery, currentProductQuery];
  const isLoading = allQueries.some(q => q.isLoading);
  const isSuccess = allQueries.every(q => q.isSuccess);
  const isDowngradeFlow = Boolean(isDowngradeEnabled && isSwitchFlow);
  const isUpgradeFlow = Boolean(!isDowngradeEnabled && isSwitchFlow);
  return {
    isSuccess,
    isLoading,
    isUpgradeFlow,
    isDowngradeFlow
  };
};
//# sourceMappingURL=useSwitchFlows.js.map